import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledQuoteButton } from './styled';
import { Icon, useStaticState } from '@phishtool/ui';
import { logEvent } from '@phishtool/analytics';
const StartTrial = ({ quotePortal }) => {
    const [staticData] = useStaticState();
    return (_jsxs(StyledQuoteButton, { href: `${staticData === null || staticData === void 0 ? void 0 : staticData.env.APP_HOST}/sign-up/enterprise-trial-from-quote/${quotePortal.token}`, onClick: () => logEvent('Portal Trial CTA Clicked', { portalId: quotePortal._id }), children: [_jsx("span", { children: "Start free trial" }), _jsx(Icon, { name: "trial", size: { width: 34, height: 36 }, alignment: "vertical" })] }));
};
export default StartTrial;
